import React from 'react'

export default ({ children }) => {
  return (
    <div className="content">
      <div className="container">{children}</div>
    </div>
  )
}